import jStat from 'jstat';
import { ConfidenceIntervalResult } from '../../components/calculators/confidence-interval/confidence-interval-calculator';

export function calculateConfidenceInterval(
  data: number[],
  confidenceLevel: number
): ConfidenceIntervalResult {
  const mean = jStat.mean(data);
  const standardDeviation = jStat.stdev(data, true); // Use sample standard deviation
  const sampleSize = data.length;
  const standardError = standardDeviation / Math.sqrt(sampleSize);
  
  // Calculate critical value (z-score for large samples, t-score for small samples)
  const alpha = 1 - confidenceLevel;
  const criticalValue = sampleSize >= 30 
    ? jStat.normal.inv(1 - alpha / 2, 0, 1)  // Z-score for large samples
    : jStat.studentt.inv(1 - alpha / 2, sampleSize - 1);  // T-score for small samples
  
  const marginOfError = criticalValue * standardError;
  const lowerBound = mean - marginOfError;
  const upperBound = mean + marginOfError;

  return {
    mean,
    standardError,
    confidenceLevel,
    sampleSize,
    lowerBound,
    upperBound,
    data
  };
} 